import { render, staticRenderFns } from "./AdminSupplier.vue?vue&type=template&id=5306c6d1&"
import script from "./AdminSupplier.vue?vue&type=script&lang=js&"
export * from "./AdminSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports